// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageTakeoffSideBarQueryVariables = Types.Exact<{
  planPackageId: Types.Scalars['ID']['input'];
  rpavId: Types.Scalars['ID']['input'];
}>;


export type PlanPackageTakeoffSideBarQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, itemLocations: Array<{ __typename?: 'Location', id: string, name: string, parents: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }> } };

export type PlanPackageTakeoffSideBar_FiltersFragment = { __typename?: 'PlanPackage', id: string, itemLocations: Array<{ __typename?: 'Location', id: string, name: string, parents: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }> };

export type Filters_ItemLocationFragment = { __typename?: 'Location', id: string, name: string, parents: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } };

export const Filters_ItemLocationFragmentDoc = gql`
    fragment Filters_ItemLocation on Location {
  ...Named
  parents {
    id
    name
    type {
      name
      code
    }
  }
  type {
    name
    code
  }
}
    ${NamedFragmentDoc}`;
export const PlanPackageTakeoffSideBar_FiltersFragmentDoc = gql`
    fragment PlanPackageTakeoffSideBar_Filters on PlanPackage {
  id
  itemLocations {
    ...Filters_ItemLocation
  }
  options {
    id
    displayName
    order
    type {
      id
      isElevation
    }
  }
  costCodes {
    ...Named
  }
}
    ${Filters_ItemLocationFragmentDoc}
${NamedFragmentDoc}`;
export const PlanPackageTakeoffSideBarDocument = gql`
    query PlanPackageTakeoffSideBar($planPackageId: ID!, $rpavId: ID!) {
  planPackage(id: $planPackageId, versionId: $rpavId) {
    ...PlanPackageTakeoffSideBar_Filters
  }
}
    ${PlanPackageTakeoffSideBar_FiltersFragmentDoc}`;

/**
 * __usePlanPackageTakeoffSideBarQuery__
 *
 * To run a query within a React component, call `usePlanPackageTakeoffSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageTakeoffSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageTakeoffSideBarQuery({
 *   variables: {
 *      planPackageId: // value for 'planPackageId'
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function usePlanPackageTakeoffSideBarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables> & ({ variables: PlanPackageTakeoffSideBarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables>(PlanPackageTakeoffSideBarDocument, options);
      }
export function usePlanPackageTakeoffSideBarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables>(PlanPackageTakeoffSideBarDocument, options);
        }
// @ts-ignore
export function usePlanPackageTakeoffSideBarSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables>;
export function usePlanPackageTakeoffSideBarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageTakeoffSideBarQuery | undefined, PlanPackageTakeoffSideBarQueryVariables>;
export function usePlanPackageTakeoffSideBarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables>(PlanPackageTakeoffSideBarDocument, options);
        }
export type PlanPackageTakeoffSideBarQueryHookResult = ReturnType<typeof usePlanPackageTakeoffSideBarQuery>;
export type PlanPackageTakeoffSideBarLazyQueryHookResult = ReturnType<typeof usePlanPackageTakeoffSideBarLazyQuery>;
export type PlanPackageTakeoffSideBarSuspenseQueryHookResult = ReturnType<typeof usePlanPackageTakeoffSideBarSuspenseQuery>;
export type PlanPackageTakeoffSideBarQueryResult = ApolloReactCommon.QueryResult<PlanPackageTakeoffSideBarQuery, PlanPackageTakeoffSideBarQueryVariables>;